import React                     from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import Button                    from '@material-ui/core/Button';
import Icon                      from '@material-ui/core/Icon';
import { Theme }                 from '@material-ui/core/styles';
import Breadcrumbs               from '../main-navigation/Breadcrumbs';
import MainContentToolbar        from '../main-navigation/MainContentToolbar';
import MainDateRangeNav          from '../ui/MainDateRangeNav';
import ScheduleControls          from '../schedule/ScheduleControls';
import timeOffModel              from './TimeOffModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    flexWrap: 'wrap',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    flex: '0 1 auto',
  },
  addButton: {
    textTransform: 'none',
    minWidth: '0px',
    flex: '0 0 auto',
    marginRight: '5px',
    marginBottom: '7px',
    '&:last-child': {
      marginRight: '0px',
    },
  },
});

interface ITimeOFfToolbarProps {
}

type TimeOffToolbarProps = WithStyle<ReturnType<typeof styles>, ITimeOFfToolbarProps>;

class TimeOffToolbar extends React.PureComponent<TimeOffToolbarProps> {
  constructor(props: TimeOffToolbarProps) {
    super(props);
  }

  addTimeOffRequest = () => {
    timeOffModel.addTimeOffRequest();
  };

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <MainContentToolbar>
        <div className={classes.left}>
          <Breadcrumbs />
          <MainDateRangeNav />
        </div>
        <div className={classes.right}>
          <Button className={classes.addButton} variant='contained' disabled={!timeOffModel.canAddTimeOffRequest} onClick={this.addTimeOffRequest}>
            <Icon className='add'>{'add'}</Icon>
            Add Time Off Request
          </Button>
          <ScheduleControls />
        </div>
      </MainContentToolbar>
    )} />;
  }
}

export default withStyles<ITimeOFfToolbarProps>(styles, TimeOffToolbar);
